import classNames from 'classnames';
import type { FC } from 'react';
import { BUBBLE_CORNERS } from '@components/Organisms/Bubble/_constants/Bubble.constants';
import type { TBubbleProps } from '@components/Organisms/Bubble/Bubble.types';

export const Bubble: FC<TBubbleProps> = ({
  children,
  className,
  corner = BUBBLE_CORNERS.TOP_LEFT,
}) => {
  const wrapperClassNames = classNames(
    'app-c-bubble',
    `app-c-bubble--${corner}`,
    className,
  );

  return <div className={wrapperClassNames}>{children}</div>;
};
